import { IDevice } from "lavva.exalushome/build/js/Services/Devices/IDevice";
import { CorrectionSteps, CorrectionType } from "../../../Common/BlindConfigurations/BlindConfigParameters";
import { BlindCalibrationState } from "lavva.exalushome/build/js/Services/Devices/IDeviceState";
import { ResponseResult } from "lavva.exalushome/build/js/Services/FieldChangeResult";
import { BlindConfigurationErrorCode } from "../../../Common/BlindConfigurations/BlindConfigService";
import { Status } from "lavva.exalushome/build/js/DataFrame";

export interface ISsr_4_0_0_0  {
    GetCorrectionStepAsync(device: IDevice, channel: number, correctionType: CorrectionType): Promise<CorrectionSteps | ResponseResult<BlindConfigurationErrorCode>>;
    SetCorrectionStepAsync(device: IDevice, channel: number, correction: number, correctionType: CorrectionType): Promise<Status>;
    RunAutomaticCalibrationAsync(device: IDevice, channel: number): Promise<BlindCalibrationState | ResponseResult<BlindConfigurationErrorCode>>;
    GetHeadSensorStatusAsync(device: IDevice, channel: number): Promise<boolean | ResponseResult<BlindConfigurationErrorCode>>;
    SwitchHeadSensorStatusAsync(enabled: boolean, device: IDevice, channel: number): Promise<Status>;
    ChangeMovementDirectionAsync(device: IDevice, channel: number): Promise<Status>;
    GetWorkLogAsync(device: IDevice, channel: number): Promise<BlindWorkStats | ResponseResult<BlindConfigurationErrorCode>>;
    GetWorkingModeAsync(device: IDevice, channel: number): Promise<WorkMode | ResponseResult<BlindConfigurationErrorCode>>;
}

export class BlindWorkStats {
    MakeVirginCount: number = 0;
    PowerOffCount: number = 0;
    EnterCalibrationCount: number = 0;
    ObstacleUpCount: number = 0;
    ObstacleDownCount: number = 0;
    GoRideUpCount: number = 0;
    GoRideDownCount: number = 0;
    ManualAutoConfigFlag: boolean = false;
    BadCrcFlag: boolean = false;
}

export enum WorkMode {
    Automatic = 0,
    Manual = 1
}